import type { GrantingRoles } from '../../modules/iam/permissions-context.js';
import { joinNames } from './join-names.js';
import { permissionLabel } from './permission-label.js';

type AccessDirectory = Readonly<{
  roleNames?: readonly string[];
  grantingRoles?: ReadonlyMap<string, GrantingRoles>;
}>;

function whoHasIt(grantors: GrantingRoles | undefined): string {
  if (!grantors || grantors.roleCount === 0) return 'No role has it yet.';
  const [first, second] = grantors.roleNames;
  if (grantors.roleCount === 1) return `${first} has it.`;
  if (grantors.roleCount === 2) return `${first} and ${second} have it.`;
  const more = grantors.roleCount - 2;
  return `${first}, ${second} and ${more} more ${more === 1 ? 'role' : 'roles'} have it.`;
}

/** "Needs Purchase Orders · Issue. Purchasing has it. You have Warehouse." — role sentences only once the directory has loaded. */
export function missingPermissionTooltip(
  missing: readonly [string, ...string[]],
  { roleNames, grantingRoles }: AccessDirectory = {},
): string {
  const sentences = [`Needs ${missing.map(permissionLabel).join(', ')}.`];
  if (grantingRoles && missing.length === 1)
    sentences.push(whoHasIt(grantingRoles.get(missing[0])));
  if (roleNames) {
    sentences.push(
      roleNames.length > 0 ? `You have ${joinNames(roleNames)}.` : 'You have no role yet.',
    );
  }
  return sentences.join(' ');
}
